import { Result, DeleteData } from 'domain/types';

import DeleteDashboardClient from 'use-case/dashboard/delete/deleteDashboardClient';
import DeleteDashboardCriteria from 'use-case/dashboard/delete/deleteDashboardCriteria';

export type DeleteDashboardResult = Result<DeleteData>;
export type DeleteDashboard = (criteria: DeleteDashboardCriteria) => Promise<DeleteDashboardResult>;

export default (deleteDashboardClient: DeleteDashboardClient): DeleteDashboard => (
    criteria: DeleteDashboardCriteria
): Promise<DeleteDashboardResult> => deleteDashboardClient(criteria);
